async function getReport({ condition, page }) {
  try {
    const resData = await window.axios.get('/api/v1/admin/purchase/report', { params: condition, page });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getSetting() {
  const res = await window.axios.get('/api/v1/admin/purchase/setting');
  return res.data;
}

async function setSetting(params) {
  const res = await window.axios.put('/api/v1/admin/purchase/setting', params);
  return res.data;
}

module.exports = { getReport, getSetting, setSetting };
